import React from 'react';
import { LuChevronRight } from 'react-icons/lu';
import { nombrePunto } from './vistasMapa';
import { diaLargo } from '../empresa/diasRuta';

// Lista de Pendientes debajo del mapa (26-oct-2026). El mapa solo mostraba puntos de colores: para saber qué
// era cada uno había que tocarlos de a uno. Acá está todo junto, por zona: qué es, hace cuánto espera y si la
// empresa ya le eligió día. Urgentes primero, después lo reservado y después lo que más espera.
// Tocar un renglón lo marca en el mapa.
const ZONAS = [['CABA', 'CABA'], ['SUR', 'Zona sur'], ['OTRA', 'Otras zonas']];
const chip = 'h-5 px-1.5 rounded-md text-[10px] font-black uppercase inline-flex items-center shrink-0';

const espera = d => (d == null ? null : d === 0 ? 'cargado hoy' : `espera ${d} día${d !== 1 ? 's' : ''}`);
const orden = (a, b) => (b.urgente - a.urgente) || (!!b.rutaFecha - !!a.rutaFecha)
    || String(a.rutaFecha || '').localeCompare(String(b.rutaFecha || '')) || ((b.esperaDias || 0) - (a.esperaDias || 0));

function Fila({ p, onElegir }) {
    const detalle = p.capa === 'pedido'
        ? [p.motivo, p.equipos > 1 ? `${p.equipos} equipos` : null, p.rutaFecha ? null : espera(p.esperaDias)]
        : [p.radar ? `${p.radar.tipo === 'FILTRO' ? 'filtro' : 'sanitización'} vencido hace ${p.radar.meses} meses` : 'service vencido', p.equipos > 1 ? `${p.equipos} equipos` : null];
    return (
        <button type="button" onClick={() => onElegir(p)} className="w-full flex items-center gap-2.5 px-3.5 py-2.5 text-left border-t first:border-t-0 border-black/[0.06] dark:border-white/[0.06] hover:bg-panel active:bg-chip">
            <span className="w-2.5 h-2.5 rounded-full shrink-0" style={{ background: p.color }} />
            <span className="flex-1 min-w-0">
                <span className="flex items-center gap-1.5 min-w-0">
                    <span className="text-caption font-black text-ink truncate">{nombrePunto(p)}</span>
                    {p.urgente && <span className={`${chip} bg-brand-red text-white`}>Urgente</span>}
                    {p.rutaFecha && <span className={`${chip} bg-[#0EA5E9] text-white`}>{diaLargo(p.rutaFecha).slice(0, 3)} {diaLargo(p.rutaFecha).split(' ')[1]}</span>}
                </span>
                <span className="block text-label text-muted truncate">{[...detalle, p.direccion].filter(Boolean).join(' · ')}</span>
            </span>
            {p.lat == null ? <span className="text-label font-bold text-brand-red shrink-0">Sin ubicar</span> : <LuChevronRight size={15} className="shrink-0 text-muted" />}
        </button>
    );
}

export default function ListaPendientes({ puntos, onElegir }) {
    const pedidos = puntos.filter(p => p.capa === 'pedido');
    const service = puntos.filter(p => p.capa === 'service' && (p.semaforo === 'rojo' || p.semaforo === 'amarillo'));
    if (!pedidos.length && !service.length) return null;
    const caja = 'rounded-2xl bg-card border border-black/[0.06] dark:border-white/[0.06] overflow-hidden';
    const grupos = ZONAS.map(([id, nombre]) => ({ id, nombre, lista: pedidos.filter(p => (p.zona || 'OTRA') === id).sort(orden) }))
        .filter(g => g.lista.length);
    return (
        <div className="space-y-3">
            {grupos.map(g => {
                const urg = g.lista.filter(p => p.urgente).length, res = g.lista.filter(p => p.rutaFecha).length;
                const eq = g.lista.reduce((a, p) => a + (p.equipos || 1), 0);
                return (
                    <section key={g.id} className="space-y-1.5">
                        <h3 className="px-1 text-label font-black text-muted uppercase tracking-widest">
                            {g.nombre} · {g.lista.length} pedido{g.lista.length !== 1 ? 's' : ''} ({eq} equipo{eq !== 1 ? 's' : ''})
                            {urg > 0 && <span className="text-brand-red"> · {urg} urgente{urg !== 1 ? 's' : ''}</span>}
                            {res > 0 && <span className="text-[#0284C7] dark:text-[#38BDF8]"> · {res} con día</span>}
                        </h3>
                        <div className={caja}>{g.lista.map(p => <Fila key={p.id} p={p} onElegir={onElegir} />)}</div>
                    </section>
                );
            })}
            {service.length > 0 && (
                <section className="space-y-1.5">
                    <h3 className="px-1 text-label font-black text-muted uppercase tracking-widest">Service vencido o por vencer · {service.length}</h3>
                    <div className={caja}>{[...service].sort((a, b) => (a.semaforo === 'rojo' ? 0 : 1) - (b.semaforo === 'rojo' ? 0 : 1)).map(p => <Fila key={p.id} p={p} onElegir={onElegir} />)}</div>
                </section>
            )}
        </div>
    );
}
